import React, { Suspense, useEffect } from "react";
import { RecoilRoot, useRecoilSnapshot } from "recoil";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { getEnv } from "./api/common";
import Loader from "./components/common/Loader";
import { MetaTag } from "./util/common";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

const DebugObserver = () => {
  const snapshot = useRecoilSnapshot();
  useEffect(() => {
    console.debug("The following atoms were modified:");
    for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
      console.debug(node.key, snapshot.getLoadable(node));
    }
  }, [snapshot]);

  return null;
};

root.render(
  <React.StrictMode>
    <RecoilRoot>
      {!getEnv() && <DebugObserver />}
      <Suspense fallback={<Loader />}></Suspense>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <MetaTag
            title="THE MAKER"
            url="https://themaker.circul.us/"
            imgsrc="https://themaker.circul.us/meta_img.png"
            description="Circulus의 교육 브랜드 THE MAKER의 학습 관리 시스템(LMS)입니다."
          />
          <App />
        </HelmetProvider>
      </QueryClientProvider>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
